<template>
    <section class="dashboard">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <h5>Bentornato, <b>{{ currentUser.username }}</b>.</h5>
                            <!-- <hr>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <a href="mailto:info@alitaliaghost.it">info@alitaliaghost.it</a><br>
                            <a href="tel:1234567890">+39 1234567890</a><br>
                            <a href="/messages" class="btn btn-success btn-block mt-3 text-white">APRI TICKET</a> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- <DIV class="row"> -->
                <!-- <div class="col-md-9"> -->
                    <div class="row mb-4">
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <font-awesome-icon icon="sliders-h" /> Filtri
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3">
                                        <div class="col">
                                            <label>Periodo</label><br>
                                            <date-picker
                                                placeholder="-- Seleziona periodo --"
                                                input-class="form-control"
                                                v-model="filters.range"
                                                range
                                            />
                                        </div>
                                        <!-- <div class="col-md-3" v-if="computedUsers && currentUser.type === 1">
                                            <label>Utente</label><br>
                                            <select class="custom-select" v-model="filters.user">
                                                <option :value="null" disabled>-- Seleziona un utente --</option>
                                                <option v-for="user in computedUsers" :key="user.id" :value="user.value">
                                                    {{ user.text }}
                                                </option>
                                            </select>
                                        </div> -->
                                        <div class="col">
                                            <label>Settore</label><br>
                                            <select class="custom-select" v-model="filters.sector">
                                                <option :value="null" disabled>-- Seleziona il settore di volo --</option>
                                                <option value="INC">INC</option>
                                                <option value="INZ">INZ</option>
                                                <option value="NAZ">NAZ</option>
                                                <option value="DOM">DOM</option>
                                            </select>
                                        </div>
                                        <!-- <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Tratta</label><br>
                                                <v-select
                                                    v-model="filters.route"
                                                    :options="routes"
                                                    :reduce="label => label.label"
                                                >
                                                </v-select>
                                            </div>
                                        </div> -->
                                    </div>
                                    <!-- <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label>Mostra solo task completati</label><br>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input v-model="filters.completed" :value="1" type="radio" class="custom-control-input" id="taskRadioYes" name="taskRadop">
                                                <label class="custom-control-label" for="taskRadioYes">Si</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input v-model="filters.completed" :value="0" type="radio" class="custom-control-input" id="taskRadioNo" name="taskRadop">
                                                <label class="custom-control-label" for="taskRadioNo">No</label>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="card-footer">
                                    <div class="row filters">
                                        <div class="col">
                                            <span class="badge badge-pill badge-success" @click="filters.range = null" v-if="filters.range">
                                                {{ $date(filters.range[0]).format('DD-MM-YYYY') }} - {{ $date(filters.range[1]).format('DD-MM-YYYY') }}
                                            </span>
                                            <span class="badge badge-pill badge-success" @click="filters.user = null" v-if="filters.user">
                                                {{ computedUser }}
                                            </span>
                                            <span class="badge badge-pill badge-success" @click="filters.sector = null" v-if="filters.sector">
                                                {{ filters.sector }}
                                            </span>
                                            <span class="badge badge-pill badge-success" @click="filters.route = null" v-if="filters.route">
                                                {{ filters.route }}
                                            </span>
                                            <button @click="resetFilters" class="btn btn-danger float-right">Resest filtri</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="projectsData" class="col-md-4 mb-3">
                            <div class="card text-white bg-info card-counter">
                                <div class="card-header">
                                    <h5 class="mb-0">Numero missioni</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 text-center">
                                            <h2>{{ projectsData.total }}</h2>
                                        </div>
                                        <div class="col-md-8">
                                            <h5 class="mt-2">Dettaglio missioni</h5>
                                            <p>
                                                <!-- Totale missioni: {{ projectsData.total }}<br> -->
                                                Completate: {{ projectsData.completed }}<br>
                                                Parziali: {{ projectsData.running }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="tasksData" class="col-md-4 mb-3">
                            <div class="card text-white bg-info card-counter">
                                <div class="card-header">
                                    <h5 class="mb-0">Numero tratte</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 text-center">
                                            <h2>{{ tasksData.total }}</h2>
                                        </div>
                                        <div class="col-md-8">
                                            <h5 class="mt-2">Dettaglio tratte</h5>
                                            <p>
                                                Totale tratte completate: {{ tasksData.completed }}<br>
                                                Totale tratte parziali: {{ tasksData.running }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="tasksData" class="col-md-4 mb-3">
                            <div class="card text-white bg-info card-counter">
                                <div class="card-header">
                                    <h5 class="mb-0">Completamento missioni</h5>
                                </div>
                                <div class="card-body text-center">
                                    <h2>{{ tasksData.percent }} <small>%</small></h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div v-if="overallData" class="col-md-6 col-lg-4">
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="mb-0">Totale conformità</h5>
                                </div>
                                <div class="card-body">
                                    <span></span>
                                    <pie-chart :chart-data="overallData" />
                                </div>
                            </div>
                        </div> -->
                        <div class="col">
                            <div v-if="worstFlight" class="card text-white bg-danger card-counter mb-4">
                                <div class="card-header">
                                    <h5 class="mb-0">Peggior volo | <small> % conformità </small></h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h4 class="mt-2">
                                                {{ worstFlight.task.task_name }}
                                                <small>
                                                    del {{ getFlightDate(worstFlight) }}
                                                </small>
                                            </h4>
                                            <p>
                                                Totale conformità: {{ worstFlight.counters.C }}<br>
                                                Totale non conformità: {{ worstFlight.counters.NC }}<br>
                                                Non valutabile: {{ worstFlight.counters.NV }}
                                            </p>
                                        </div>
                                        <div class="col">
                                            <div class="counter">
                                                <svg class="circle-chart" viewbox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg">
                                                    <circle class="circle-chart__background" stroke="rgba(255,255,255,.3)" stroke-width="5" fill="none" cx="45" cy="45" r="40" />
                                                    <circle class="circle-chart__circle" stroke="white" stroke-width="5" :stroke-dasharray="[dashArray(worstValue), this.circumference]" stroke-linecap="square" fill="none" cx="45" cy="45" r="40" />
                                                </svg>
                                                <h3>
                                                    <number
                                                        ref="worstFlight"
                                                        :from="0"
                                                        :to="worstValue"
                                                        :duration="4"
                                                        :delay="1"
                                                        easing="Power1.easeOut"
                                                    />
                                                    <small>&#37;</small>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="bestFlight" class="card text-white bg-success card-counter">
                                <div class="card-header">
                                    <h5 class="mb-0">Miglior volo | <small> % conformità </small></h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h4 class="mt-2">
                                                {{ bestFlight.task.task_name }}
                                                <small>
                                                    del {{ getFlightDate(bestFlight) }}
                                                </small>
                                            </h4>
                                            <p>
                                                Totale conformità: {{ bestFlight.counters.C }}<br>
                                                Totale non conformità: {{ bestFlight.counters.NC }}<br>
                                                Non valutabile: {{ bestFlight.counters.NV }}
                                            </p>
                                        </div>
                                        <div class="col">
                                            <div class="counter">
                                                <svg class="circle-chart" viewbox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg">
                                                    <circle class="circle-chart__background" stroke="rgba(255,255,255,.3)" stroke-width="5" fill="none" cx="45" cy="45" r="40" />
                                                    <circle class="circle-chart__circle" stroke="white" stroke-width="5" :stroke-dasharray="[dashArray(bestValue), this.circumference]" stroke-linecap="square" fill="none" cx="45" cy="45" r="40" />
                                                </svg>
                                                <h3>
                                                    <number
                                                        ref="bestFlight"
                                                        :from="0"
                                                        :to="bestValue"
                                                        :duration="4"
                                                        :delay="1"
                                                        easing="Power1.easeOut"
                                                    />
                                                    <small>&#37;</small>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
            <!-- </div> -->
            <div class="row">
                <div class="col-md-4 col-xl-3 mb-3">
                    <!-- <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">Totale conformità</h5>
                        </div>
                        <div class="card-body">
                            <span></span>
                            <pie-chart
                                v-if="overallData"
                                :chart-data="overallData"
                            />
                        </div>
                    </div> -->
                </div>
                <!-- <div class="col-md-4 col-xl-3 mb-3">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">Totale tratte</h5>
                        </div>
                        <div class="card-body">
                            <doughnut-chart
                                v-if="tasksData"
                                :chart-data="tasksData"
                            />
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row mb-3">
                <!-- <div class="col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <span>Conformità</span>
                            <bar-chart
                                v-if="complianceData"
                                :chart-data="complianceData"
                                :options="barchartOptions"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <span>Non conformità</span>
                            <bar-chart
                                v-if="noncomplianceData"
                                :chart-data="noncomplianceData"
                                :options="barchartOptions"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <span>Non valutabile</span>
                            <bar-chart
                                v-if="nonvalutableData"
                                :chart-data="nonvalutableData"
                                :options="barchartOptions"
                            />
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </section>
</template>
<script>
// const colors = {
//     total: '#5DA9E9',
//     completed: '#00663F',
//     running: '#FFCC00',
//     nc: '#941605'
// }
import {
    MODULE_NAME as USERS_MODULE_NAME
} from '@/store/modules/users.module'
import {
    mapGetters
} from 'vuex'
import {
    GET_LIST
} from '@/store/actions.type'
// import BarChart from './HomeComponents/BarChart'
// import PieChart from './HomeComponents/PieChart'
// import DoughnutChart from './HomeComponents/DoughnutChart'
import {
    StatsService
} from '@/common/api.service'
import ApiService from '@/common/api.service'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
    name: 'home',
    data () {
        return {
            projectsData: false,
            routes: [],
            tasksData: false,
            overallData: false,
            circumference: 251, /** Circumference = 2 * π * Radius */
            complianceData: false,
            noncomplianceData: false,
            nonvalutableData: false,
            worstFlight: false,
            bestFlight: false,
            filters: {
                route: null,
                range: null,
                user: null,
                sector: null,
                completed: 0
            },
            barchartOptions: {
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            users: `${USERS_MODULE_NAME}/getList`
        }),
        computedUsers () {
            var _users = []
            if (this.users.data) {
                let allUsers = this.users.data
                for (var i = 0; i < allUsers.length; i++) {
                    var u = {
                        value: allUsers[i].id,
                        text: allUsers[i].email
                    }
                    _users.push(u)
                }
            }
            return _users
        },
        computedUser () {
            if (this.filters.user) {
                let u = this.computedUsers.find((u) => {
                    return u.value === this.filters.user
                })
                return u.text
            }
            return null
        },
        worstValue () {
            if (this.worstFlight) {
                let total = this.worstFlight.counters.C + this.worstFlight.counters.NC + this.worstFlight.counters.NV
                if ( total === 0 ) return 0
                return this.worstFlight.counters.C / total * 100
            }
            return 0
        },
        bestValue () {
            if (this.bestFlight) {
                let total = this.bestFlight.counters.C + this.bestFlight.counters.NC + this.bestFlight.counters.NV
                return this.bestFlight.counters.C / total * 100
            }
            return 0
        },
        query () {
            return {
                completed: this.filters.completed,
                ft: this.filters.sector,
                rt: this.filters.route,
                user: this.filters.user,
                from: this.filters.range ? this.$date(this.filters.range[0]).format('YYYY-MM-DD') : null,
                to: this.filters.range ? this.$date(this.filters.range[1]).format('YYYY-MM-DD') : null
            }
        }
    },
    mounted () {
        this.fetchRoutes()
        this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_LIST}`, {
            query: {}
        })
    },
    methods: {
        fetchRoutes () {
            ApiService.query('routes').then((result) => {
                if (result.data.routes) {
                    this.routes = result.data.routes.map((r) => {
                        r.label = `${r.route_from}-${r.route_to}`
                        return r
                    })
                    // console.log(this.routes)
                }
            })
        },
        // Valutare soluzione alternativa più flessibile;
        fetchData () {
            StatsService.get('projects', this.query).then((r) => {
                this.projectsData = r.data
                // let _pj = {
                //     datasets: [{
                //         data: [],
                //         backgroundColor: []
                //     }],
                //     labels: []
                // }
                // for (var key in r.data) {
                //     if (r.data.hasOwnProperty(key)) {
                //         _pj.datasets[0].data.push(r.data[key])
                //         _pj.datasets[0].backgroundColor.push(colors[key])
                //         _pj.labels.push(key)
                //     }
                // }
                // this.projectsData = _pj
            })
            StatsService.get('tasks', this.query).then((r) => {
                this.tasksData = r.data
                // let _tk = {
                //     datasets: [{
                //         data: [],
                //         backgroundColor: []
                //     }],
                //     labels: []
                // }
                // for (var key in r.data) {
                //     if (r.data.hasOwnProperty(key)) {
                //         _tk.datasets[0].data.push(r.data[key])
                //         _tk.datasets[0].backgroundColor.push(colors[key])
                //         _tk.labels.push(key)
                //     }
                // }
                // this.tasksData = _tk
            })
            StatsService.get('compliance', this.query).then((r) => {
                let mainData = r.data
                if (mainData.length) {

                    /**
                     * TRATTA PEGGIORE / MIGLIORE
                     */
                    // Estraggo il volo peggiore (minor numero di C);
                    let worstValue = Math.min.apply(Math, mainData.map(function (o) {
                        return o.counters.C
                    }))
                    let worstFlight = mainData.find(function (o) {
                        return o.counters.C === worstValue
                    })
                    if (worstFlight) this.worstFlight = worstFlight
                    // Estraggo il volo peggiore (maggior numero di C);
                    let bestValue = Math.max.apply(Math, mainData.map(function (o) {
                        return o.counters.C
                    }))
                    let bestFlight = mainData.find(function (o) {
                        return o.counters.C === bestValue
                    })
                    if (bestFlight) this.bestFlight = bestFlight
                    /**
                     * DATI PER OVERALL PIE CHART
                     */
                    let counters = mainData.map(a => a.counters)
                    let _ctotal = counters.reduce((a, b) => a + (b['C'] || 0), 0)
                    let _nctotal = counters.reduce((a, b) => a + (b['NC'] || 0), 0)
                    let _nvtotal = counters.reduce((a, b) => a + (b['NV'] || 0), 0)
                    let _overall = _ctotal + _nctotal + _nvtotal
                    this.overallData = {
                        datasets: [{
                            data: [
                                Math.round((_ctotal / _overall * 100) * 100) / 100,
                                Math.round((_nctotal / _overall * 100) * 100) / 100,
                                Math.round((_nvtotal / _overall * 100) * 100) / 100
                            ],
                            backgroundColor: ['#5DA9E9', '#00663F', '#FFCC00'],
                        }],
                        labels: ['% conformità', '% non conformità', '% non valutabile']
                    }
                } else {
                    this.worstFlight = false
                    this.bestFlight = false
                    this.overallData = false
                }
            })
        },
        resetFilters () {
            this.filters = {
                rt: null,
                completed: 0,
                range: null,
                user: null,
                sector: null
            }
        },
        dashArray (value) {
            return this.circumference / 100 * value
        },
        getFlightDate (flight) {
            if (flight.task && flight.task.metas) {
                let routeDate = flight.task.metas.find((m) => {
                    return m.meta_key === 'route_date'
                })
                return this.$date(routeDate.pivot.meta_value).format('DD-MM-YYYY')
            }
            return false
        }
    },
    watch: {
        query: {
            handler () {
                this.fetchData()
            },
            immediate: true,
            deep: true
        }
    },
    components: {
        // PieChart,
        // BarChart,
        DatePicker,
        // DoughnutChart
    }
}
</script>
<style lang="scss">
.card-counter {
    h2 {
        font-size: 4rem;
        font-weight: 700;
    }
    .counter {
        width: 90px;
        position: relative;
        text-align: center;
        h3 {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 1.4rem;
            text-align: center;
            margin: 0;
        }
        .circle-chart {
            margin-bottom: 10px;
            margin-top: 10px;
            &__circle {
                animation: circle-chart-fill 4s reverse;
                transform: rotate(-90deg);
                transform-origin: center;
            }
        }
    }
}
@keyframes circle-chart-fill {
    to {
        stroke-dasharray: 0 251;
    }
}
</style>
